// Comprehensive exam data for 14 competitive exams

export const examData = {
  'rbi-grade-b': {
    id: 'rbi-grade-b',
    name: 'RBI Grade B',
    fullName: 'Reserve Bank of India Grade B Officer',
    icon: '🏛️',
    color: 'red',
    metaTitle: 'RBI Grade B 2026: Exam Dates, Syllabus, Salary & Preparation',
    metaDescription: 'Complete guide to RBI Grade B exam - notification, eligibility, pattern, syllabus, salary, preparation strategy & more.',
    
    overview: {
      intro: 'The RBI Grade B exam is conducted annually to recruit Managers (Grade B Officers) into the Reserve Bank of India. It is one of the most prestigious banking exams in India.',
      conductedBy: 'Reserve Bank of India',
      level: 'Manager (Grade B)',
      frequency: 'Annual',
      mode: 'Online'
    },

    notification: {
      expected: 'July-September 2026',
      lastYear: 'September 10, 2025',
      applicationStart: 'On the date of notification release',
      lastDate: '20-25 days after notification',
      phase1Exam: 'To be announced',
      phase2Exam: 'To be announced',
      interview: 'To be announced'
    },

    vacancy: {
      expected: '100-120 posts',
      lastYear: '120 posts',
      trend: 'Varies annually between 80-150 posts'
    },

    eligibility: {
      age: {
        min: 21,
        max: 30,
        relaxation: 'Age relaxation for reserved categories as per RBI norms'
      },
      education: 'Postgraduate in any discipline with minimum 55% marks (50% for SC/ST/PwBD) OR Graduate with minimum 60% marks (50% for SC/ST/PwBD)',
      nationality: 'Indian citizen or subject of Nepal/Bhutan',
      attempts: '6 attempts for General/EWS; Unlimited for SC/ST/OBC/PwBD'
    },

    examPattern: {
      phases: [
        {
          name: 'Phase 1 (Prelims)',
          type: 'Qualifying',
          mode: 'Online',
          sections: [
            { subject: 'General Awareness', questions: 80, marks: 80, time: 25 },
            { subject: 'Reasoning Ability', questions: 60, marks: 60, time: 45 },
            { subject: 'English Language', questions: 30, marks: 30, time: 25 },
            { subject: 'Quantitative Aptitude', questions: 30, marks: 30, time: 25 }
          ],
          totalQuestions: 200,
          totalMarks: 200,
          totalTime: 120,
          negativeMarking: '1/4 mark for each wrong answer'
        },
        {
          name: 'Phase 2 (Mains)',
          type: 'Merit-based',
          mode: 'Online',
          papers: [
            { name: 'Economic & Social Issues (ESI)', type: '50% Objective + 50% Descriptive', marks: 100, time: 120 },
            { name: 'Descriptive English', type: 'Descriptive (Precis, RC, Essay)', marks: 100, time: 90 },
            { name: 'Finance & Management (FM)', type: '50% Objective + 50% Descriptive', marks: 100, time: 120 }
          ],
          totalMarks: 300,
          negativeMarking: '1/4 mark for objective questions'
        },
        {
          name: 'Phase 3 (Interview)',
          type: 'Personality Test',
          marks: 75,
          psychometric: 'Mandatory but non-scoring'
        }
      ]
    },

    syllabus: {
      phase1: [
        {
          subject: 'General Awareness',
          topics: ['Banking & Financial Awareness', 'Current Affairs (last 6 months)', 'RBI & SEBI Announcements', 'National & International News', 'Government Schemes', 'Awards & Honours', 'Sports', 'Books & Authors', 'Static GK']
        },
        {
          subject: 'Reasoning Ability',
          topics: ['Puzzles & Seating Arrangement', 'Syllogism', 'Coding-Decoding', 'Blood Relations', 'Direction Sense', 'Inequality', 'Data Sufficiency', 'Input-Output', 'Statement & Assumptions']
        },
        {
          subject: 'English Language',
          topics: ['Reading Comprehension', 'Grammar', 'Vocabulary', 'Error Spotting', 'Sentence Improvement', 'Cloze Test', 'Para Jumbles', 'Fill in the Blanks']
        },
        {
          subject: 'Quantitative Aptitude',
          topics: ['Data Interpretation', 'Number Series', 'Simplification', 'Quadratic Equations', 'Profit & Loss', 'Time & Work', 'Ratio & Proportion', 'Percentage', 'Average', 'Simple & Compound Interest', 'Probability']
        }
      ],
      phase2: [
        {
          paper: 'Economic & Social Issues',
          topics: ['Indian Economy', 'Growth & Development', 'Globalization', 'Social Structure in India', 'Economic Reforms', 'Fiscal & Monetary Policy']
        },
        {
          paper: 'Finance & Management',
          topics: ['Financial System', 'Financial Markets', 'Banking Operations', 'Fundamentals of Management', 'Organizational Behaviour', 'Leadership', 'Corporate Governance', 'Ethics']
        },
        {
          paper: 'Descriptive English',
          topics: ['Essay Writing', 'Precis Writing', 'Reading Comprehension', 'Letter Writing']
        }
      ]
    },

    salary: {
      basic: '₹78,450 per month',
      grossAnnual: '₹18 lakh',
      allowances: '₹12 lakh',
      otherBenefits: '₹2 lakh',
      totalCTC: '₹32-34 lakh per annum',
      components: ['House Rent Allowance (HRA)', 'Dearness Allowance (DA)', 'Transport Allowance', 'Medical Benefits', 'Pension Benefits']
    },

    jobProfile: {
      designation: 'Manager (Grade B Officer)',
      responsibilities: [
        'Overseeing regulation, supervision & enforcement',
        'Managing financial markets & foreign exchange',
        'Currency management & financial inclusion',
        'Monetary policy formulation',
        'Research & financial stability',
        'Governance, HR & customer service'
      ],
      workCulture: 'Professional, no public dealing, excellent work-life balance',
      postings: 'Mumbai HQ or 30+ regional offices across India',
      transfers: 'Every 3-5 years'
    },

    careerGrowth: [
      { position: 'Manager (Grade B)', duration: 'Joining' },
      { position: 'Assistant General Manager (Grade C)', duration: 'After 7 years' },
      { position: 'Deputy General Manager (Grade D)', duration: 'After 11 years' },
      { position: 'General Manager (Grade E)', duration: 'After 15 years' },
      { position: 'Chief General Manager (Grade F)', duration: 'After 19 years' },
      { position: 'Deputy Governor / Governor', duration: 'Based on merit' }
    ],

    preparationTips: [
      'Start with Phase 1 syllabus - cover all 4 subjects thoroughly',
      'Focus heavily on Current Affairs (last 6 months) for General Awareness',
      'Practice daily mock tests to improve speed and accuracy',
      'For Phase 2, read standard books for ESI and FM',
      'Develop strong writing skills for descriptive papers',
      'Solve previous year papers (2019-2024)',
      'Join quality test series for Phase 1 & 2',
      'Allocate 6-8 months for comprehensive preparation'
    ],

    cutoff: {
      phase1: { 2024: 67.25, 2023: 54.25, 2022: 63.75, 2021: 66.75 },
      phase2: { 2024: 173.50, 2023: 169, 2022: 171.25, 2021: 187.75 },
      final: { 2024: 226.75, 2023: 229, 2022: 234.50, 2021: 252.25 }
    },

    applicationFee: {
      general: '₹850 + 18% GST',
      scSt: '₹100 (intimation charges only) + 18% GST',
      pwbd: '₹100 (intimation charges only) + 18% GST'
    },

    examCenters: [
      { zone: 'North', cities: ['Delhi', 'Chandigarh', 'Jaipur', 'Lucknow', 'Kanpur'] },
      { zone: 'South', cities: ['Bengaluru', 'Chennai', 'Hyderabad', 'Kochi', 'Thiruvananthapuram'] },
      { zone: 'East', cities: ['Kolkata', 'Patna', 'Bhubaneswar', 'Guwahati', 'Raipur'] },
      { zone: 'West', cities: ['Mumbai', 'Ahmedabad', 'Pune', 'Nagpur', 'Bhopal'] }
    ]
  },

  'nabard-grade-a': {
    id: 'nabard-grade-a',
    name: 'NABARD Grade A',
    fullName: 'National Bank for Agriculture and Rural Development - Grade A',
    icon: '🌾',
    color: 'green',
    
    overview: {
      intro: 'NABARD Grade A exam recruits Assistant Managers in development banking sector focused on agriculture and rural development.',
      conductedBy: 'National Bank for Agriculture and Rural Development',
      level: 'Assistant Manager (Grade A)',
      frequency: 'Annual',
      mode: 'Online'
    },

    notification: {
      expected: 'August-September 2026',
      applicationDuration: '30 days approximately'
    },

    vacancy: {
      expected: '150-200 posts',
      streams: ['General', 'Rajbhasha', 'Legal', 'IT', 'HR']
    },

    eligibility: {
      age: { min: 21, max: 30 },
      education: "Bachelor's degree in any discipline with minimum 50% marks (45% for SC/ST/PwBD)",
      nationality: 'Indian citizen'
    },

    examPattern: {
      phases: [
        {
          name: 'Phase 1 (Prelims)',
          sections: [
            { subject: 'Reasoning', questions: 40, marks: 40, time: 20 },
            { subject: 'English Language', questions: 40, marks: 40, time: 20 },
            { subject: 'Quantitative Aptitude', questions: 40, marks: 40, time: 20 },
            { subject: 'General Awareness', questions: 40, marks: 40, time: 20 },
            { subject: 'Computer Knowledge', questions: 40, marks: 40, time: 20 }
          ],
          totalMarks: 200,
          totalTime: 100
        },
        {
          name: 'Phase 2 (Mains)',
          papers: [
            { name: 'Economic & Social Issues', marks: 100, time: 90 },
            { name: 'Agriculture & Rural Development', marks: 100, time: 90 },
            { name: 'English Writing Skills', marks: 100, time: 90 }
          ]
        }
      ]
    },

    salary: {
      basic: '₹44,500 per month',
      totalCTC: '₹25-28 lakh per annum',
      components: ['HRA', 'DA', 'Medical Benefits', 'Pension']
    }
  },

  'ssc-cgl': {
    id: 'ssc-cgl',
    name: 'SSC CGL',
    fullName: 'Staff Selection Commission - Combined Graduate Level',
    icon: '📚',
    color: 'blue',
    
    overview: {
      intro: 'SSC CGL is one of the most popular government exams in India, recruiting for Group B and C posts across various ministries and departments.',
      conductedBy: 'Staff Selection Commission',
      level: 'Graduate Level (Group B & C)',
      frequency: 'Annual',
      mode: 'Online'
    },

    notification: {
      expected: 'June-July 2026',
      applicationDuration: '30 days'
    },

    vacancy: {
      expected: '15,000+ posts',
      posts: ['Inspector', 'Auditor', 'Tax Assistant', 'Statistical Investigator', 'Accountant']
    },

    eligibility: {
      age: { min: 18, max: 32 },
      education: "Bachelor's Degree from a recognized university",
      nationality: 'Indian citizen'
    },

    examPattern: {
      phases: [
        {
          name: 'Tier 1',
          sections: [
            { subject: 'General Intelligence & Reasoning', questions: 25, marks: 50 },
            { subject: 'General Awareness', questions: 25, marks: 50 },
            { subject: 'Quantitative Aptitude', questions: 25, marks: 50 },
            { subject: 'English Comprehension', questions: 25, marks: 50 }
          ],
          totalQuestions: 100,
          totalMarks: 200,
          totalTime: 60
        },
        {
          name: 'Tier 2',
          papers: [
            { name: 'Quantitative Abilities', questions: 100, marks: 200 },
            { name: 'English Language & Comprehension', questions: 200, marks: 200 },
            { name: 'Statistics (for specific posts)', questions: 100, marks: 200 }
          ]
        },
        {
          name: 'Tier 3',
          type: 'Descriptive (Essay/Letter/Application)',
          marks: 100
        },
        {
          name: 'Tier 4',
          type: 'Skill Test / Computer Proficiency Test'
        }
      ]
    },

    salary: {
      range: '₹44,900 - ₹2,08,700 per month',
      payLevel: 'Level 4 to Level 8 (7th Pay Commission)'
    }
  },

  'ssc-chsl': {
    id: 'ssc-chsl',
    name: 'SSC CHSL',
    fullName: 'Staff Selection Commission - Combined Higher Secondary Level',
    icon: '✏️',
    color: 'purple',
    
    overview: {
      intro: 'SSC CHSL recruits for Lower Division Clerk (LDC), Data Entry Operator (DEO), and Postal Assistant posts.',
      conductedBy: 'Staff Selection Commission',
      level: '10+2 Level',
      frequency: 'Annual'
    },

    vacancy: {
      expected: '10,000+ posts',
      posts: ['LDC', 'DEO', 'Postal Assistant', 'Sorting Assistant']
    },

    eligibility: {
      age: { min: 18, max: 27 },
      education: '12th Pass from recognized board'
    },

    salary: {
      range: '₹25,500 - ₹81,100 per month',
      payLevel: 'Level 2 (7th Pay Commission)'
    }
  },

  'ssc-mts': {
    id: 'ssc-mts',
    name: 'SSC MTS',
    fullName: 'Staff Selection Commission - Multi Tasking Staff',
    icon: '🔧',
    color: 'orange',
    
    overview: {
      intro: 'SSC MTS recruits for non-technical support staff positions in various government offices.',
      conductedBy: 'Staff Selection Commission',
      level: 'Matriculation Level'
    },

    vacancy: {
      expected: '8,000+ posts',
      posts: ['Peon', 'Daftary', 'Jamadar', 'Chowkidar', 'Mali']
    },

    eligibility: {
      age: { min: 18, max: 25 },
      education: '10th Pass (Matriculation)'
    },

    salary: {
      range: '₹18,000 - ₹56,900 per month',
      payLevel: 'Level 1 (7th Pay Commission)'
    }
  },

  'ssc-cpo': {
    id: 'ssc-cpo',
    name: 'SSC CPO',
    fullName: 'Staff Selection Commission - Central Police Organization',
    icon: '👮',
    color: 'navy',
    
    overview: {
      intro: 'SSC CPO recruits Sub-Inspectors in Delhi Police, CAPF, and CISF.',
      conductedBy: 'Staff Selection Commission',
      level: 'Sub-Inspector'
    },

    vacancy: {
      expected: '5,000+ posts',
      posts: ['Sub Inspector (Delhi Police)', 'Sub Inspector (CAPF)', 'ASI (CISF)']
    },

    eligibility: {
      age: { min: 20, max: 25 },
      education: "Bachelor's Degree",
      physical: 'Physical Efficiency Test (PET) & Physical Standard Test (PST) required'
    },

    salary: {
      range: '₹44,900 - ₹1,42,400 per month',
      payLevel: 'Level 6 (7th Pay Commission)'
    }
  },

  'ssc-gd': {
    id: 'ssc-gd',
    name: 'SSC GD Constable',
    fullName: 'Staff Selection Commission - General Duty Constable',
    icon: '🛡️',
    color: 'maroon'
  },

  'ssc-steno': {
    id: 'ssc-steno',
    name: 'SSC Stenographer',
    fullName: 'Staff Selection Commission - Stenographer Grade C & D',
    icon: '⌨️',
    color: 'teal'
  },

  'sbi-po': {
    id: 'sbi-po',
    name: 'SBI PO',
    fullName: 'State Bank of India - Probationary Officer',
    icon: '🏦',
    color: 'green',
    
    overview: {
      intro: 'SBI PO is one of the most prestigious banking exams, recruiting Probationary Officers for India\'s largest public sector bank.',
      conductedBy: 'State Bank of India',
      level: 'Officer Scale I'
    },

    vacancy: {
      expected: '2,000-2,500 posts'
    },

    eligibility: {
      age: { min: 21, max: 30 },
      education: "Bachelor's Degree with 60% marks (55% for SC/ST/PwBD)"
    },

    salary: {
      basic: '₹41,960 per month',
      totalCTC: '₹14-16 lakh per annum'
    }
  },

  'sbi-clerk': {
    id: 'sbi-clerk',
    name: 'SBI Clerk',
    fullName: 'State Bank of India - Junior Associate',
    icon: '💼',
    color: 'blue'
  },

  'ibps-po': {
    id: 'ibps-po',
    name: 'IBPS PO',
    fullName: 'Institute of Banking Personnel Selection - Probationary Officer',
    icon: '🏛️',
    color: 'red'
  },

  'ibps-clerk': {
    id: 'ibps-clerk',
    name: 'IBPS Clerk',
    fullName: 'Institute of Banking Personnel Selection - Clerical Cadre',
    icon: '📋',
    color: 'orange'
  },

  'ibps-rrb-po': {
    id: 'ibps-rrb-po',
    name: 'IBPS RRB PO',
    fullName: 'IBPS Regional Rural Banks - Officer Scale I',
    icon: '🌾',
    color: 'green'
  },

  'ibps-rrb-clerk': {
    id: 'ibps-rrb-clerk',
    name: 'IBPS RRB Clerk',
    fullName: 'IBPS Regional Rural Banks - Office Assistant',
    icon: '📝',
    color: 'brown'
  }
};

// Helper function to get exam by ID
export const getExamById = (examId) => {
  return examData[examId] || null;
};

// Get all exams grouped by category
export const getExamsByCategory = () => {
  return {
    'RBI & NABARD': ['rbi-grade-b', 'nabard-grade-a'],
    'SSC Exams': ['ssc-cgl', 'ssc-chsl', 'ssc-mts', 'ssc-cpo', 'ssc-gd', 'ssc-steno'],
    'Bank PO': ['sbi-po', 'ibps-po', 'ibps-rrb-po'],
    'Bank Clerk': ['sbi-clerk', 'ibps-clerk', 'ibps-rrb-clerk']
  };
};
